(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myl-compatibility-reading"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('myl-compatibility')) {
 customElements.define('myl-compatibility', class extends HTMLElement {
 connectedCallback() {
  if(this.dataset.ready) return; this.dataset.ready='true';
  this.querySelectorAll('.cp-thumb').forEach(link=>link.addEventListener('click',e=>{
   const main=this.querySelector('.cp-gallery-main'); const img=main?.querySelector('img'); if(!img)return;
   e.preventDefault(); img.srcset=link.dataset.srcset||''; img.src=link.dataset.src; img.alt=link.dataset.alt; main.href=link.href;
   this.querySelectorAll('.cp-thumb').forEach(t=>t.removeAttribute('aria-current'));link.setAttribute('aria-current','true');
  }));
  const today=new Date(); const maxDate=[today.getFullYear(),String(today.getMonth()+1).padStart(2,'0'),String(today.getDate()).padStart(2,'0')].join('-');
  this.querySelectorAll('.cp-date').forEach(i=>i.max=maxDate);
  this.querySelectorAll('.cp-time-certainty').forEach(s=>{
   const sync=()=>{const f=s.closest('fieldset').querySelector('.cp-time-field');const i=f.querySelector('input');const known=s.value==='Known';f.hidden=!known;i.disabled=!known;i.required=known;if(!known)i.value='';};
   s.addEventListener('change',sync);sync();
  });
  this.querySelectorAll('a[href="#cp-order"]').forEach(a=>a.addEventListener('click',e=>{
   const target=this.querySelector('#cp-order');if(!target)return;e.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }));
  const form=this.querySelector('form');if(form){form.addEventListener('submit',e=>{if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}if(form.dataset.preview==='true'){e.preventDefault();const msg=this.querySelector('.cp-preview-result');if(msg){msg.hidden=false;msg.textContent='Preview check passed: both people’s details are complete. No order was placed.';}}});}
 }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myl-relationship-reading"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.myl-page .myl-time-certainty').forEach(s=>{s.addEventListener('change',()=>{const f=s.closest('form').querySelector('.myl-time-field'),i=f.querySelector('input');f.hidden=s.value!=='Known';i.disabled=f.hidden;i.required=!f.hidden;if(f.hidden)i.value='';});});document.querySelectorAll('.myl-page input[type=date]').forEach(i=>{i.max=new Date().toISOString().slice(0,10);});

if (!customElements.get('myl-reading-gallery')) {
  customElements.define('myl-reading-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.mylGalleryReady) return;
      this.mylGalleryReady = true;
      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('.myl-gallery-thumbnail');
        if (!thumbnail || !this.contains(thumbnail) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const stage = this.querySelector('.myl-product-art');
        const image = stage?.querySelector('img');
        if (!image) return;
        event.preventDefault();
        image.srcset = thumbnail.dataset.imageSrcset;
        image.src = thumbnail.dataset.imageSrc;
        image.alt = thumbnail.dataset.imageAlt;
        image.width = Number(thumbnail.dataset.imageWidth);
        image.height = Number(thumbnail.dataset.imageHeight);
        stage.href = thumbnail.href;
        this.querySelectorAll('.myl-gallery-thumbnail').forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
        const counter = this.querySelector('[data-gallery-index]');
        if (counter) counter.textContent = thumbnail.dataset.imageIndex;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
